import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function softDeleteTest(id, userInfo) {
	return fetch(
		`${ENDPOINT_URL}/test/${id}/retrieve`,
		getFetchOptions({
			method: 'PATCH',
			body: JSON.stringify(userInfo),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
